import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const tenantAdminApi = {
  tenant: () => axios.get(`${API}/api/tenant-admin/tenant`, { withCredentials: true }).then(r => r.data),
  usage:  () => axios.get(`${API}/api/tenant-admin/usage`, { withCredentials: true }).then(r => r.data),

  listUsers: () => axios.get(`${API}/api/tenant-admin/users`, { withCredentials: true }).then(r => r.data),
  getUserProfile: (id, days = 90) =>
    axios
      .get(`${API}/api/tenant-admin/users/${id}/profile`, {
        withCredentials: true,
        params: { days },
      })
      .then((r) => r.data),
  getUserAppointments: (id, period = 'month') =>
    axios
      .get(`${API}/api/tenant-admin/users/${id}/appointments`, {
        withCredentials: true,
        params: { period },
      })
      .then((r) => r.data),
  invite: (body) => axios.post(`${API}/api/tenant-admin/users`, body, { withCredentials: true }).then(r => r.data),
  updateUser: (id, body) => axios.patch(`${API}/api/tenant-admin/users/${id}`, body, { withCredentials: true }).then(r => r.data),
  deactivateUser: (id) =>
    axios.post(`${API}/api/tenant-admin/users/${id}/deactivate`, {}, { withCredentials: true }).then((r) => r.data),
  reactivateUser: (id) =>
    axios.post(`${API}/api/tenant-admin/users/${id}/reactivate`, {}, { withCredentials: true }).then((r) => r.data),
  removeUser: (id) =>
    axios.post(`${API}/api/tenant-admin/users/${id}/deactivate`, {}, { withCredentials: true }).then((r) => r.data),

  plans: () => axios.get(`${API}/api/tenant-admin/billing/plans`, { withCredentials: true }).then(r => r.data),
  transactions: () => axios.get(`${API}/api/tenant-admin/billing/transactions`, { withCredentials: true }).then(r => r.data),
  upgrade: (body) => axios.post(`${API}/api/tenant-admin/billing/upgrade`, body, { withCredentials: true }).then(r => r.data),
  checkoutStatus: (sid) => axios.get(`${API}/api/tenant-admin/billing/checkout/${sid}`, { withCredentials: true }).then(r => r.data),

  domains: () => axios.get(`${API}/api/tenant-admin/domains`, { withCredentials: true }).then(r => r.data),
  addDomain: (domain) => axios.post(`${API}/api/tenant-admin/domains`, { domain }, { withCredentials: true }).then(r => r.data),
  removeDomain: (domain) => axios.delete(`${API}/api/tenant-admin/domains/${encodeURIComponent(domain)}`, { withCredentials: true }).then(r => r.data),
};
